
import React from 'react';
import Particle from './../../Particle';
import {Paragraph, Title, Image} from './../../Basics';

const Particle05 = () => (<div>

  <Title>The wheelchair developer</Title>

   <Paragraph>
    The team at the Hochschule Rapperswil spent many months developing a stair-climbing wheelchair. Prior to the
    competition, the project leader Christian Bermes described what drives him and his colleagues.
    Christian Bermes is a professor at the Institute for Lab Automation and Mechatronics in Rapperswil.
  </Paragraph>
                          
  <Paragraph>
    <b>Christian, why do you and your team wish to compete in the Cybathlon?</b>
    To begin with, I found the idea of such a tournament very exciting. In the past, I have had very little
    contact with physically disabled people, but thanks to Florian Hauser, our pilot, I can now see the
    obstacles these individuals face on a daily basis. When hurdles cannot be overcome, this is usually due to a
    lack of appropriate technical solutions. I would like to help improve the quality of life of those concerned.
  </Paragraph>

   <Image
    source={require('./christian-bermes.png')}
    title='Porträtfoto Christian Bermes'
    caption={<span>Christian Bermes ist Professor am Institut für Laborautomation und
    Mechatronik der Hochschule für Technik in Rapperswil. Foto: HSR</span>}
  />
   
  <Paragraph>
    <b>Does the Cybathlon promote the development of new wheelchairs?</b>
    The competition will not necessarily lead to a marketable product. But we will be seeing very interesting
    partial solutions, for example stair-climbing wheelchair models such as ours. Stairways remain an insurmountable
    obstacle for wheelchair users.
  </Paragraph>

  <Particle
    number={9}
  />

  <Paragraph>
    <b>Why are stair-climbing models not on the market yet?</b>
    I do not believe that this is due to technical issues. But possibly the market is too small, which means that
    elaborate product development will not pay off for the manufacturer.
  </Paragraph>


  <Image
    source={require('./04_Einzelteile_Bild_HSR.jpg')}
    title='Die Einzelzeile des treppensteigenden Rollstuhls'
    caption='Jetzt ist Zusammenbauen angesagt: Die Einzelteile des treppensteigenden Rollstuhls.'
  />
            
  <Paragraph>
    <b>How do you rate your chances of winning the competition?</b>
    I think we are in a good position. We have an intrepid pilot who will stop at nothing and who is willing to go
    flat-out when needed. However, boldness is not enough. The team with the best combination of pilot and technology
    will win. Both are required for success. I believe that our technology can accomplish a fair bit. At first, no one
    believed we could get this far, as we only started the development last December. That’s an extremely short period
    of time. Nevertheless, I believe we have a few surprises in store.
  </Paragraph>

</div>);

export default Particle05;



/** WEBPACK FOOTER **
 ** ./src/Particles/Particle05/Particle05_EN.js
 **/